export const SKILL_CATEGORIES: Record<string, string[]> = {
  "Wedding & Events": [
    "Wedding Photography", "Pre-wedding shoot", "Maternity shoot", "Engagement",
    "Candid photography", "Traditional shoot", "Cinematic shoot",
    "Conceptual shoot", "Bridal Portraits", "Haldi/Mehendi", "Reception",
    "Sangeet", "Couple Portraits", "Wedding Teaser", "Save the Date",
    "Post-wedding shoot", "Destination Wedding", "Event Photography",
    "Corporate Events", "Concerts", "Festivals", "Parties", "Conferences",
    "Sports Photography", "Nightlife Photography"
  ],
  "Fashion": [
    "Fashion Photography", "High Fashion", "Editorial", "Street Style", "Catalog",
    "Runway", "Swimwear", "Lingerie", "Fitness Photography", "Beauty Photography"
  ],
  "Commercial": [
    "Commercial Photography", "Product Photography", "Food Photography", "Real Estate Photography", "E-commerce Photography",
    "Advertising", "Corporate", "Industrial", "Architecture Photography",
    "Automotive Photography", "Jewelry Photography"
  ],
  "Portrait": [
    "Portrait Photography", "Headshots", "Family Photography", "Newborn Photography", "Pet Photography",
    "Corporate Headshots", "Environmental Portraits", "Senior Portraits", "Boudoir Photography",
    "Lifestyle Photography"
  ],
  "Nature & Landscape": [
    "Landscape Photography", "Wildlife Photography", "Astrophotography", "Macro Photography", "Travel Photography",
    "Underwater Photography", "Cityscape Photography", "Aerial / Drone Photography", "Fine Art Photography",
    "Street Photography", "Documentary Photography", "Drone Photography", "Photojournalism"
  ],
  "Makeup & Styling": [
    "SFX", "Theatrical", "Airbrush", "HD Makeup", "Prosthetics", "Body Painting",
    "Wardrobe", "Prop Styling", "Food Styling", "Set Design", "Personal Shopping", "Fashion Consulting", "Bridal"
  ],
  "Modeling & Talent": [
    "Parts Modeling", "Acting", "Dancing", "Posing", "Fitness"
  ],
  "Technical & Post-Processing": [
    "Studio Lighting", "Natural Light", "Retouching", "Color Grading", "Film Photography", 
    "Digital Photography", "Composite", "Photo Editing", "Video Editing"
  ]
};
